export default __webpack_public_path__ + "circle_logo.png";